/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactFromJSON, StreemApiArtifactToJSON, } from './';
export function StreemApiFulfillRecordingResponseFromJSON(json) {
    return StreemApiFulfillRecordingResponseFromJSONTyped(json, false);
}
export function StreemApiFulfillRecordingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'recordingArtifact': !exists(json, 'recording_artifact') ? undefined : StreemApiArtifactFromJSON(json['recording_artifact']),
    };
}
export function StreemApiFulfillRecordingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'recording_artifact': StreemApiArtifactToJSON(value.recordingArtifact),
    };
}
//# sourceMappingURL=StreemApiFulfillRecordingResponse.js.map